import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IconArrowUp } from "../Icons";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";
import { useScrolledPast } from "../hooks/useScrollPosition";
import { ScrollUpButton } from "./styles";

/**
 * Resets scroll on navigation.
 *
 * Without this, following a footer link to the Terms page from halfway down the
 * home page drops you halfway down the Terms page — the classic SPA papercut.
 */
export const ScrollToTopOnNavigate = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

/** Floating "back to top" control, revealed once you're a screen or two down. */
const ScrollToTop = () => {
  const visible = useScrolledPast(600);
  const reducedMotion = usePrefersReducedMotion();

  return (
    <ScrollUpButton
      $visible={visible}
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: reducedMotion ? "auto" : "smooth",
        })
      }
      aria-label="Back to top"
      tabIndex={visible ? 0 : -1}
    >
      <IconArrowUp size={18} />
    </ScrollUpButton>
  );
};

export default ScrollToTop;
